var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Chart',{attrs:{"cdata":_vm.nowData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }